export enum COMMON_LOGGER_LOG_LEVEL {
	FATAL = 'Fatal',  // Something bad happened; application is going down
	ERROR = 'Error',  // Something failed; application may or may not continue
	WARN = 'Warn',  // Something unexpected; application will continue
	INFO = 'Info',  // Normal behavior like mail sent, user updated profile etc.
	DEBUG = 'Debug',  // For debugging; executed query, user authenticated, session expired
	TRACE = 'Trace',  // For trace debugging; begin method X, end method X,
}
